/**
 * Post-processing config for easy tuning.
 * Adjust these values to match the original site appearance.
 */
export const postProcessConfig = {
	/** Exposure (0.8–1.0 recommended, lower = darker) */
	exposure: 0.88,
	/** Bloom threshold (0.5–0.7, higher = less bloom) */
	bloomThreshold: 0.6,
	/** Gamma correction exponent (1/2.2 ≈ sRGB) */
	gamma: 1 / 2.2
};
